import { gridSize } from '@atlaskit/theme/constants';
var gridSizeTimes = function gridSizeTimes(n) {
  return n * gridSize();
};
export default gridSizeTimes;